import { BaseView } from './BaseView';
import { registerSchema } from './transform';

export class TransactionHistoryItem {
  Id: number = 0;
  Date: Date = new Date();
  TransactionType: string = '';
  Days: number | null | undefined = null;
  Amount: number | null | undefined = null;
  Currency: string = '';
  TransactionId: string = '';
  CertificateDays: number | null | undefined = null;
}

export class TransactionHistoryView extends BaseView {
  Items: TransactionHistoryItem[] = [];
}

export class GiftCertificateItem {
  Id: number = 0;
  DatePurchased: Date = new Date();
  Code: string = '';
  Days: number = 0;
  DateRedeemed: Date | null | undefined = null;
  RedeemedBy: string | null | undefined = null;
  /** Purchased = issued to the member; Redeemed = someone else's certificate the member redeemed */
  Kind: 'Purchased' | 'Redeemed' = 'Purchased';
}

export class GiftCertificatesView extends BaseView {
  Items: GiftCertificateItem[] = [];
}

export class PlanInfo {
  Code: number = 0;
  Price: number = 0;
}

export class PlansInfo {
  Monthly: PlanInfo = new PlanInfo();
  Quarterly: PlanInfo = new PlanInfo();
  Yearly: PlanInfo = new PlanInfo();
  Combo: PlanInfo | null | undefined = null;
}

export class CCBillProviderInfo {
  FlexId: string = '';
  SubAccount: string = '';
  Plans: PlansInfo = new PlansInfo();
}

export class ProvidersInfo {
  CCBill: CCBillProviderInfo | null | undefined = null;
}

export class SubscribeInfo {
  BillingEnabled: boolean = false;
  IsPremium: boolean = false;
  PremiumEndsOnUtc: Date | null | undefined = null;
  LastCCBillSubscriptionId: string = '';
  IsOldPricingEligible: boolean = false;
  Providers: ProvidersInfo = new ProvidersInfo();
}

registerSchema(TransactionHistoryItem, {
  Date: 'date',
});

registerSchema(TransactionHistoryView, {
  Items: [TransactionHistoryItem],
});

registerSchema(GiftCertificateItem, {
  DatePurchased: 'date',
  DateRedeemed: 'date',
});

registerSchema(GiftCertificatesView, {
  Items: [GiftCertificateItem],
});

registerSchema(PlanInfo, {});

registerSchema(PlansInfo, {
  Monthly: PlanInfo,
  Quarterly: PlanInfo,
  Yearly: PlanInfo,
  Combo: PlanInfo,
});

registerSchema(CCBillProviderInfo, {
  Plans: PlansInfo,
});

registerSchema(ProvidersInfo, {
  CCBill: CCBillProviderInfo,
});

registerSchema(SubscribeInfo, {
  PremiumEndsOnUtc: 'date',
  Providers: ProvidersInfo,
});


